import React, { memo } from 'react'

export const VideoIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
  >
    <path
      d="M2.8125 1.125C2.06658 1.125 1.35121 1.41948 0.823762 1.94365C0.296316 2.46782 0 3.17874 0 3.92003V13.9821C0 14.7234 0.296316 15.4344 0.823762 15.9585C1.35121 16.4827 2.06658 16.7772 2.8125 16.7772H15.1875C15.9334 16.7772 16.6488 16.4827 17.1762 15.9585C17.7037 15.4344 18 14.7234 18 13.9821V3.92003C18 3.17874 17.7037 2.46782 17.1762 1.94365C16.6488 1.41948 15.9334 1.125 15.1875 1.125H2.8125ZM7.61063 5.68202L12.1106 8.47929C12.1902 8.52893 12.2561 8.59761 12.3021 8.67905C12.3482 8.76049 12.3729 8.8521 12.3741 8.9455C12.3754 9.03891 12.353 9.13113 12.3092 9.21374C12.2653 9.29635 12.2013 9.36672 12.123 9.41842L7.623 12.38C7.53823 12.4358 7.43983 12.4677 7.33827 12.4723C7.23671 12.477 7.13579 12.4541 7.04624 12.4063C6.95668 12.3585 6.88185 12.2874 6.82968 12.2007C6.77752 12.114 6.74998 12.0149 6.75 11.9138V6.15606C6.75 6.05627 6.77688 5.9583 6.82784 5.87233C6.8788 5.78635 6.95199 5.7155 7.03982 5.66712C7.12764 5.61875 7.22689 5.59462 7.32726 5.59724C7.42764 5.59986 7.52548 5.62913 7.61063 5.68202Z"
      fill="currentColor"
    />
  </svg>
))
